import { ActionReducerMap } from '@ngrx/store';
import * as fromAccountLanguages from './account-languages';
import { AccountManagementState } from './account-management.state';
import * as fromManagement from './management';

export const reducers: ActionReducerMap<AccountManagementState> = {
    management: fromManagement.managementReducer,
    languages: fromAccountLanguages.accountLanguagesReducer
}
